import { SignupContainer } from 'apps/auth/scripts/containers';

interface Props {
  onLogin: () => void;
  onSuccess: () => void;
}

const OnboardingAuthSignup = ({ onLogin, onSuccess }: Props) => {
  return (
    <SignupContainer
      onSuccess={onSuccess}
      onLogin={onLogin}
      onboarding
    />
  );
};

OnboardingAuthSignup.displayName = 'OnboardingAuthSignup';

export default OnboardingAuthSignup;
